window.addEventListener('load', () => {

});

window.addEventListener('resize', () => {

});
